import axios from "axios";

const API_DOMAIN = process.env.REACT_APP_TPOC_API_DOMAIN;

/**
 * Generates Fee Breakdown PDF and returns PDF Blob
 * 
 * @param {string} token - Access token (AuthCode or generated token)
 * @param {string} loanId - Loan GUID
 * @param {Array<{name: string, value: string}>} fields - Field name/value pairs
 * @returns {Promise<Blob>} - PDF Blob
 */
export const generateFeeBreakdownPdf = async (token, loanId, loanNumber, fields) => {
    const url = `${API_DOMAIN}/api/FeeBreakdown/generate`;

    const payload = {
        LoanId: loanId,
        AuthCode: token,
        Fields: fields,
        LoanNumber: loanNumber
    };

    try {
        const response = await axios.post(url, payload, {
            responseType: "blob" // to receive raw PDF data
        });

        if (response.status === 200) {
            return new Blob([response.data], { type: "application/pdf" });
        }

        throw new Error(`Unexpected status: ${response.status}`);
    } catch (error) {
        console.error("Error generating Fee Breakdown PDF:", error);
        throw error;
    }
};

export const generateAssetDepletionPdf = async (authCode, loanId, loanNumber, payload) => {
    const url = `${API_DOMAIN}/api/AssetDepletion/generate`;

    const req = {
        LoanId: loanId,
        LoanNumber: loanNumber,
        AuthCode: authCode,
        ...payload
    };

    // no responseType needed
    const response = await axios.post(url, req);

    if (response.status === 200) return true;
    throw new Error(`Unexpected status: ${response.status}`);
};

export const generateFeeBreakdownV2Pdf = async (token, loanId, loanNumber, fields) => {
    const url = `${API_DOMAIN}/api/FeeBreakdown/v2/generate`;

    const payload = {
        LoanId: loanId,
        AuthCode: token,
        Fields: fields,
        LoanNumber: loanNumber
    };

    try {
        const response = await axios.post(url, payload, {
            responseType: "blob"
        });

        if (response.status === 200) {
            return new Blob([response.data], { type: "application/pdf" });
        }

        throw new Error(`Unexpected status: ${response.status}`);
    } catch (error) {
        console.error("Error generating Fee Breakdown V2 PDF:", error);
        throw error;
    }
};